import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

class Toastify {
    // Static method to show a toast
    public static show = (text: string, opts?: ToastOptions): void => {
        toast(text, opts);
    };

    // You can add additional static methods for different types of toasts
    public static success = (text: string, opts?: ToastOptions): void => {
        toast.success(text, opts);
    };

    public static error = (text: string, opts?: ToastOptions): void => {
        toast.error(text, opts);
    };

    public static info = (text: string, opts?: ToastOptions): void => {
        toast.info(text, opts);
    };

    public static warn = (text: string, opts?: ToastOptions): void => {
        toast.warn(text, opts);
    };
}

export default Toastify;
